// extracted by mini-css-extract-plugin
module.exports = {"container":"character-slider-module--container--1yuN5","characterWrapper":"character-slider-module--characterWrapper--22RrV"};